import { AlignmentType, Paragraph, TextRun, WidthType } from "docx"

export function conclusionText1(certInApplicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 600 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION Security Auditors conducted Mobile Application Security Audit on the given ${certInApplicationName} Mobile Application.`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}
export const conclusionText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 5000, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Audit Conducted By: ",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 200, after: 100 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Mr. Sai Madhav [CEH]",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})
export const conclusionText4 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 650, after: 150 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Report Prepared By:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})
export const conclusionText5 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 100, after: 600 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Mr. Sai Madhav [CEH]",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export const conclusionText6 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 750, after: 150 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Report Reviewed By:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText7 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 100 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Mr. Manjunath NG (Director)",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const conclusionText8 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 80 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "ISECURION Technology & Consulting Pvt. Ltd",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})
export const conclusionText9 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 80, after: 80 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Bangalore",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,

        }),
    ],
})

export function conclusionText10(dateString) {
    const [dayStr, monthStr, yearStr] = dateString.split('/');
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-based
    const year = parseInt(yearStr, 10);

    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
        throw new Error(`Invalid dateString: ${dateString}`);
    }

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const ordinalSuffix = getOrdinalSuffix(day);
    const formattedDay = `${day}${ordinalSuffix} ${monthNames[month]} ${year}`;

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 400 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: formattedDay,
                font: "Calibri",
                size: 22,
                color: '000000',
                italics: false
            }),
            
        ],
    })
}